<template>
  <b-row>
    <b-col lg="12">
      <b-card header="En proceso">
        <div class="form-group form-inline pull-right">
          <date-picker v-model="date.start" lang="es" type="date" required format="DD/MM/YYYY"></date-picker>&nbsp;
          <date-picker v-model="date.end" lang="es" type="date" required format="DD/MM/YYYY"></date-picker>&nbsp;
          <button @click="getRqs()" type="button" class="btn btn-primary">Buscar</button>&nbsp;
          <download-excel
            class="btn btn-primary"
            :data="filteredRqs"
            :fields="json_fields"
            name="servicios_en_curso.xls"
          >Descargar Excel</download-excel>
        </div>
        <div class="form-group form-inline pull-left">
          <input v-model="search" type="search" class="form-control" placeholder="Buscar"> &nbsp;
        </div>
        <div class="table-responsive rqTable">
          <table class="table table-striped table-bordered table-hover">
            <thead>
              <tr>
                <th>BL/Booking</th>
                <th>Servicio</th>
                <th>Llenado en almacén</th>
                <th>Horario de llenado</th>
                <th>Depósito de retiro</th>
                <th>Depósito de devolución (impo) o entrega full (expo)</th>
                <th>Fecha operación (cita)</th>
                <th>Número Contenedor</th>
                <th>Precinto de línea</th>
                <th>Precinto de aduana</th>
                <th>Tara</th>
                <th>Placa</th>
                <th>Conductor</th>
                <th>Celular conductor</th>
                <th>Estado</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(rq, k) in paginated('filteredRqs')"
                @contextmenu.prevent="selectRq(rq)"
                :key="k"
              >
                <td>{{rq.service.doc_number}}</td>
                <td>
                  {{rq.service.service_type.name}}
                  <span v-html="linkOriginal(rq)"/>
                </td>
                <td>{{rq.service.service_type.code === constants.EXPORTACION ? (rq.fill ? 'SI' : 'NO') : '--'}}</td>
                <td>{{rq.date_fill | formatDateTime}}</td>
                <td>{{rq.deposit_pick ? rq.deposit_pick.name : ''}}</td>
                <td>{{rq.fill ? '' : (rq.deposit ? rq.deposit.name : '')}}</td>
                <td>{{(rq.service.service_type.code === constants.ARRUMAJE ? rq.service.date : rq.date) | formatDateTime}}</td>
                <td>{{rq.container_number}}</td>
                <td>{{rq.seal_line}}</td>
                <td>{{rq.seal_customs}}</td>
                <td>{{rq.seal_tare}}</td>
                <td>{{rq.truck && rq.driver_confirm === 'ACP' ? rq.truck.plate : '--'}}</td>
                <td>{{rq.driver && rq.driver_confirm === 'ACP' ? `${rq.driver.name} ${rq.driver.last_name}` : '--'}}</td>
                <td>{{rq.truck && rq.driver_confirm === 'ACP' ? rq.truck.mobile : '--'}}</td>
                <td>{{rq.status.name}}</td>
              </tr>
            </tbody>
          </table>
          <paginate name="filteredRqs" :list="filteredRqs" class="paginate-list" :per="10" :refreshCurrentPage="false"></paginate>
          <paginate-links
            for="filteredRqs"
            :limit="5"
            :show-step-links="true"
            :step-links="{next: '>>',prev: '<<'}"
            :classes="{'ul': 'pagination','li': 'page-item','a': 'page-link'}"
          ></paginate-links>
          <context-menu id="context-menu" ref="ctxMenu">
            <li @click="Detail()" class="ctx-item">Ver detalle</li>
          </context-menu>
        </div>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import api from "@/helpers/api";
import constants from "@/constants";
import moment from 'moment';
import inprogress from '@/helpers/json_fields/inprogress'
export default {
  data() {
    return {
      rqs: [],
      rqsByDate: [],
      search: "",
      paginate: ["filteredRqs"],
      constants: null,
      date: {
        start: moment().format('YYYY-MM-DD 00:00:00'),
        end: moment().format('YYYY-MM-DD 23:59:59')
      },
      json_fields: inprogress
    };
  },
  computed: {
    filteredRqs() {
      return this.rqsByDate.filter(rq => {
        let condition = true
        if(this.search){
          condition = (rq.service.doc_number && rq.service.doc_number.toLowerCase().includes(this.search.toLowerCase())) ||
                      (rq.service.service_type && rq.service.service_type.name.toLowerCase().includes(this.search.toLowerCase())) ||
                      (rq.truck && rq.truck.plate.toLowerCase().includes(this.search.toLowerCase())) ||
                      (rq.container_number && rq.container_number.toLowerCase().includes(this.search.toLowerCase()))
        }
        return condition;
      });
    }
  },
  mounted() {
    this.constants = constants;
    this.getRqs()
  },
  methods: {
    getRqs(){
      const data = {
        start_date: moment(this.date.start).format('YYYY-MM-DD 00:00:00'),
        end_date: moment(this.date.end).format('YYYY-MM-DD 23:59:59'),
      }
      api.post("/company_requeriments", data).then(response => {
        this.rqs = response.requeriments;
        this.rqsByDate = this.rqs;
      });
    },
    selectRq(rq) {
      this.rq = rq;
      this.$refs.ctxMenu.open();
    },
    Detail() {
      const url = `/${this.rq.service.service_type.void ? 'voids':'requeriments'}/${this.rq.service.service_type.url}/detail/${this.rq.id}`
      this.$router.push(url);
    },
    linkOriginal(rq) {
      if (rq.service.code === constants.ARRUMAJE) {
        return `[<a href='/requeriments/detail/${
          rq.requeriment_id
        }' title="Servicio principal">${rq.requeriment_id} - ${
          rq.original.service.name
        }</a>]`;
      }
    },
  },
  sockets: {
    connect() {
      console.log("conectado");
    },
    updateRequeriment(rq) {
      let index = this.rqs.findIndex(r => r.id === rq.id);
      if (index >= 0) {
        this.rqs.splice(index, 1, rq);
      }
    }
  }
};
</script>